// В.2.f-1: Доктор Франк (liv_doktor_franken, legendary, 5/2/6).
// Приказ при выставлении: воскрешает юнита с максимальной atk из ОБОИХ
// сбросов (своего и вражеского) на свою сторону.
//
// Поведение:
//   - Кандидаты: все живые-бывшие юниты в обоих сбросах. Сравнение по
//     base.atk (template-значению), а не current.
//   - Тай-брейк случайный через rng.
//   - Если в обоих сбросах нет юнитов — Приказ сгорает.
//   - Если у Доктора на стороне нет свободного слота — Приказ сгорает.
//   - resurrectUnit(state, deadCard, ownerIdx, null) — воскрешает на
//     стороне Доктора, даже если карта была из вражеского сброса.
//     ownerId на воскрешённой карте обновится через placeCard внутри
//     resurrectUnit.
//   - Молчание Доктора блокирует Приказ.

import { resurrectUnit } from './resurrect.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_doktor_franken';
const LABEL = 'Доктор Франк';

registerImplementedAbility(CARD_ID, 'order');

export function doktorFrankenOrder(state, ownerIdx, doktor /*, opts */) {
  if (!doktor || !doktor.isAlive()) return;
  if (doktor.current?.silenced) return;
  const me = state.players?.[ownerIdx];
  const enemy = state.players?.[1 - ownerIdx];
  if (!me || !enemy) return;
  if (!me.hasFreeSlot()) {
    state.log?.add(`🔁 ${LABEL} [${me.name}]: нет свободной ячейки — Приказ сгорает`);
    return;
  }
  // Все юниты-карты в обоих сбросах + откуда они.
  const candidates = [];
  for (const c of me.discard) {
    if (c?.type === 'unit') candidates.push({ card: c, fromOwn: true });
  }
  for (const c of enemy.discard) {
    if (c?.type === 'unit') candidates.push({ card: c, fromOwn: false });
  }
  if (candidates.length === 0) {
    state.log?.add(`🔁 ${LABEL} [${me.name}]: в сбросах нет юнитов — Приказ сгорает`);
    return;
  }
  // Найти максимальную base.atk и собрать всех с этой atk.
  let maxAtk = -Infinity;
  for (const c of candidates) {
    const a = c.card.base?.atk ?? 0;
    if (a > maxAtk) maxAtk = a;
  }
  const tied = candidates.filter(c => (c.card.base?.atk ?? 0) === maxAtk);
  const pick = tied.length === 1 ? tied[0] : tied[state.rng.int(tied.length)];
  // resurrectUnit ищет dead в discard ПО ССЫЛКЕ — поэтому вызываем правильную сторону.
  // Если карта во вражеском сбросе, мы воскрешаем её на нашу сторону — но
  // resurrectUnit извлекает из discard игрока side. Нужно сначала переместить
  // карту в наш сброс ИЛИ изменить логику. Проще: вручную убрать из
  // вражеского сброса и положить в наш, потом resurrectUnit.
  if (!pick.fromOwn) {
    const idx = enemy.discard.indexOf(pick.card);
    if (idx >= 0) enemy.discard.splice(idx, 1);
    me.discard.push(pick.card);
    pick.card.ownerId = ownerIdx;
  }
  const ok = resurrectUnit(state, pick.card, ownerIdx, null);
  if (!ok) {
    state.log?.add(`🔁 ${LABEL} [${me.name}]: воскрешение не состоялось`);
    return;
  }
  state.log?.add(
    `🔁 ${LABEL} [${me.name}]: воскрешает ${pick.card.name_ru} ` +
    `(${pick.fromOwn ? 'из своего сброса' : 'из вражеского сброса'}) с ${maxAtk} atk`
  );
}
